export default __webpack_public_path__ + "degree.68c0652.png";